"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dropdown = void 0;
var Utilities_1 = require("../../Utilities");
var Dropdown_base_1 = require("./Dropdown.base");
var Dropdown_styles_1 = require("./Dropdown.styles");
exports.Dropdown = (0, Utilities_1.styled)(Dropdown_base_1.DropdownBase, Dropdown_styles_1.getStyles, undefined, {
    scope: 'Dropdown',
});
exports.Dropdown.displayName = 'Dropdown';
//# sourceMappingURL=Dropdown.js.map